const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const DropdownSelect = require("../core/view/DropdownSelect");
const ImageLoadSwitch = require("../core/view/ImageLoadSwitch");
const QuantitySelect = require("./QuantitySelect");
const AT = require("../core/vault/ActionTypes");
const OpsCart = require("./vault/OpsCart");
const ApparelUtil = require("../core/util/ApparelUtil");
const CopyTable = require("./data/CopyTable");
const HoverButton = require("./HoverButton");
const ArrowIcon = require("../core/view/ArrowIcon");
const {track} = require("../core/util/Mixpanel");
const styles = require("./styles/ApparelSection.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ApparelSectionView",

		propTypes: {
			apparelHash: PT.string.isRequired,
			addApparel: PT.func,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				size: "youth-small",
				quantity: 1,
				viewingFront: true,
				showSizing: false,
			};
		},

		openSizing: function() {
			this.setState({showSizing: !this.state.showSizing});
		},

		closeSizing: function() {
			this.setState({showSizing: false});
		},

		onAddCartClick: function() {
			track("Apparel Item Added to Cart", {
				sku: this.props.apparelHash,
				size: this.state.size,
				quantity: this.state.quantity,
			});
			this.props.addApparel && this.props.addApparel();
			this.props.dispatch({
				type: AT.ADD_ITEM_TO_CART,
				sku: `${this.props.apparelHash}-${this.state.size}`,
				quantity: this.state.quantity,
				options: {
					apparelHash: this.props.apparelHash,
					size: this.state.size,
				},
				skipModal: true,
			});
		},

		updateSize: function(size) {
			this.setState({size});
		},

		updateQuantity: function(qty) {
			this.setState({quantity: qty});
		},

		updateViewFront: function(viewingFront) {
			this.setState({viewingFront});
		},

		renderBuySection: function() {
			const sku = `${this.props.apparelHash}-${this.state.size}`;
			const price = OpsCart.getItemPriceString(
				[{sku: sku, quantity: this.state.quantity}],
				{sku}
			);
			const availableSkus = ApparelUtil.getAvailableApparelSkusByPrefix(
				this.props.apparelHash
			);
			const sizeDescriptions = _.pickBy(
				ApparelUtil.getAllApparelSizeDescriptions(),
				(d, size) => {
					return _.includes(availableSkus, `${this.props.apparelHash}-${size}`);
				}
			);

			return (
				<div className={styles.buyContainer}>
					<div className={styles.sizeSelectionContainer}>
						<div className={styles.text}>{"Size:"}</div>
						<div className={styles.sizeContainer}>
							<DropdownSelect
								className={styles.dropdown}
								initialValue={this.state.size}
								options={sizeDescriptions}
								updateSelection={this.updateSize}
								optionHeight={30}
								tabIndex={1}
							/>
						</div>
					</div>
					<div className={styles.buy}>
						<div className={styles.text}>Qty</div>
						<QuantitySelect
							className={styles.qty}
							initialValue={this.state.quantity}
							minQty={1}
							maxSelectable={5}
							updateQuantity={this.updateQuantity}
							tabIndex={2}
						/>
						<div className={styles.price}>{price}</div>
					</div>
					<HoverButton
						additionalClass={styles.addButton}
						tabIndex={3}
						onClick={this.onAddCartClick}
						text={"ADD TO CART"}
					/>
				</div>
			);
		},

		renderApparelDescription: function(apparelHash) {
			const apparelDescription = CopyTable.getApparelDescription(apparelHash);
			return (
				<div className={styles.description}>
					{apparelDescription.description}
					<br />
					{apparelDescription.availableIn}
				</div>
			);
		},

		renderImage: function(topClassName, apparelHash) {
			const viewingFront = this.state.viewingFront;
			const key = apparelHash + " " + (viewingFront ? "front" : "back");
			const viewFrontClass = `${styles.inlineLink} ${
				viewingFront ? "" : styles.unselectedFrontBackLink
			}`;
			const viewBackClass = `${styles.inlineLink} ${
				viewingFront ? styles.unselectedFrontBackLink : ""
			}`;
			return (
				// If you change an image src on Chrome but leave the same element, it
				// renders the original src until the new one loads, which is confusing on
				// slow networks. The key property here ensures it dumps the old image.
				<div className={topClassName}>
					<div className={styles.container}>
						<ImageLoadSwitch
							className={styles.apparelImage}
							key={key}
							alt={key}
							imageSrc={ApparelUtil.getApparelImageSrc(
								apparelHash,
								viewingFront,
								"large"
							)}
							fallbackImageSrc={ApparelUtil.getApparelImageSrc(
								apparelHash,
								viewingFront,
								"tiny-blur"
							)}
						/>
						<div className={styles.frontBackSelector}>
							<span
								className={viewFrontClass}
								onClick={() => this.updateViewFront(true)}
							>
								Front
							</span>
							{" / "}
							<span
								className={viewBackClass}
								onClick={() => this.updateViewFront(false)}
							>
								Back
							</span>
						</div>
					</div>
				</div>
			);
		},

		render: function() {
			const {apparelHash} = this.props;
			const {showSizing} = this.state;

			const tableContainerStyle = showSizing
				? styles.tableContainer
				: styles.tableContainerHidden;

			return (
				<div className={styles.main}>
					<div className={styles.content}>
						{this.renderImage(styles.leftImage, apparelHash)}
						<div className={styles.divider} />
						<div className={styles.info}>
							<h1 className={styles.title}>{"Beast Academy Tee"}</h1>
							{this.renderImage(styles.rightImage, apparelHash)}
							{this.renderBuySection()}
							{this.renderApparelDescription(apparelHash)}
							<div className={styles.sizeChartLinkContainer}>
								<div className={styles.sizeChartLink} onClick={this.openSizing}>
									Youth Sizing
								</div>
								<div className={styles.sizeChartArrow}>
									<ArrowIcon
										direction={showSizing ? "up" : "down"}
										colorName="blue"
										size="fit"
									/>
								</div>
							</div>
						</div>
					</div>
					<div className={tableContainerStyle}>
						<table className={styles.sizingTable}>
							<tbody>
								<tr>
									<td className={styles.topLeftSizingCell} />
									<td>Youth Small</td>
									<td>Youth Medium</td>
									<td>Youth Large</td>
									<td>Youth X-Large</td>
								</tr>
								<tr>
									<td>Shirt Length</td>
									<td>22"</td>
									<td>23 1/2"</td>
									<td>25"</td>
									<td>26 1/2"</td>
								</tr>
								<tr>
									<td>Shirt Width</td>
									<td>17"</td>
									<td>18"</td>
									<td>19"</td>
									<td>20"</td>
								</tr>
							</tbody>
						</table>
						<img
							className={styles.sizingDiagram}
							src="/assets/images/apparel/shirt-sizing-diagram.png"
							alt="Sizing"
						/>
					</div>
				</div>
			);
		},
	})
);
